/* unplugin-vue-components disabled */import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=748261de&lang=scss"
import "./login.vue?vue&type=style&index=1&id=748261de&lang=scss&scoped=true"

import exportComponent from "/Users/haonanzeng/Desktop/PigGTEx-Portal/piggtex-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748261de"]])

export default __exports__